import React, { useState } from 'react'
import { Formik, Form } from 'formik'
import PropTypes from 'prop-types'
import cmsMediaCreateScheme from 'domains/cms-media/create-form/cms-media-create-scheme'
import { FormGroup, FormText, Label } from 'reactstrap'
import ImageDropzoneMultiple from 'components/molecules/image-dropzone-multiple'
import { LoaderButton } from 'components/molecules'

const propTypes = {
  handleSubmitForm: PropTypes.func
}

const defaultProps = {
  handleSubmitForm: () => {}
}

const CmsMediaCreateForm = ({ handleSubmitForm }) => {
  const [ images, setImages ] = useState([])

  const handleDrop = (formik, fieldName, acceptedFiles) => {
    const updatedImages = images.concat(acceptedFiles)
    formik.setFieldValue(fieldName, updatedImages)
    setImages(updatedImages)
  }

  const handleClickRemove = (formik, fieldName, removedFile) => {
    const updatedImages = images.filter((image) => image !== removedFile)
    formik.setFieldValue(fieldName, updatedImages)
    setImages(updatedImages)
  }

  const handleClickRemoveAll = (formik, fieldName) => {
    formik.setFieldValue(fieldName, [])
    setImages([])
  }

  return (
    <Formik
      enableReinitialize={ true }
      initialValues={{ images: [] }}
      validationSchema={ cmsMediaCreateScheme }
      onSubmit={ handleSubmitForm }
    >
      {
        (formik) => (
          <Form>
            <FormGroup>
              <Label className='font-weight-bolder'>Select Images</Label>
              <div className='mb-2'>
                <FormText>{ 'Image files only. (*.jpeg or *.png)' }</FormText>
                <FormText>{ 'Maximum file size is 3MB' }</FormText>
              </div>
              <ImageDropzoneMultiple
                imageUrl={ formik.values.image_url }
                files={ formik.values.images }
                placeholder='Drag & drop or click to select file'
                onDrop={ (acceptedFile) => handleDrop(formik, 'images', acceptedFile) }
                onClickRemove={ (removedFile) => handleClickRemove(formik, 'images', removedFile) }
                onClickRemoveAll={ () => handleClickRemoveAll(formik, 'images') }
              />
              {
                formik.errors.images && (
                  <div className='text-warning'>{ formik.errors.images }</div>
                )
              }
            </FormGroup>
            <LoaderButton
              className='w-100'
              isLoading={ formik.isSubmitting }
              onClick={ formik.submitForm }
              block={ false }
              color='primary'
              text="Submit"
            />
          </Form>
        )
      }
    </Formik>
  )
}

CmsMediaCreateForm.propTypes    = propTypes
CmsMediaCreateForm.defaultProps = defaultProps

export default CmsMediaCreateForm
